module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAPCAYAAAD3T6+hAAAAAXNSR0IArs4c6QAAAQhJREFUOBFjZCAAMh976P359zsYpoyDjW3KZMntr0H8lEeu2Yz//4lhk4OJodNM6ALo/L//f6cxMDIy/Wdi/AfCP/+z/IepYWL4DxZDl0t77JKT88hVCqaO5nTqQ+ezKQ/djLFZRNCH2DRRIkbQwtRHLiWFj92FKLEEWS9BCxkY/mf8ZGAgzUJGpsncHBxPkC2CsVlgDGrSs+V2L8BlHhE+xKWVPHGCFjL+Z+pm4+F8Q4rx+LIFwSCdJb97JimWgdQCc2fiDwam40DmM3S9BH2IroFSPkELh362wFcAg+T+//+nzMBIWkDCsgU2s1lABfA/YKEMMxK9cGZgZA6cJrvzDkyeFBqb2QA6TnFjOW20iQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart5-icon/temp basal.png
// module id = 1295
// module chunks = 7